export enum Status {
  requested = 'requested',
  changeRequested = 'change',
  accepted = 'accepted',
  rejected = 'rejected',
  processing = 'processing',
  paid = 'paid',
  rated = 'rated',
  completed = 'completed',
  cancelled = 'cancelled',
}

export const StatusArray = [
  'requested',
  'change',
  'accepted',
  'rejected',
  'processing',
  'paid',
  'rated',
  'completed',
  'cancelled',
];

/** Statuses that wait on a host or an admin: booking requests, change requests and payments in processing. */
export const WaitingStatusArray: string[] = [Status.requested, Status.changeRequested, Status.processing];
